<template>
  <article class="z1 absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center">
    <div
      class="absolute z1 top-0 left-0 right-0 bottom-0 invert-w-opc"
      @click="$emit('hide-popup')"
    ></div>

    <slot></slot>
  </article>
</template>

<script>

export default { name: 'PopUp' };
</script>
